export default __webpack_public_path__ + "static/media/Snd1.e7b99079.mp3";